<div class="navbar  sticky-top navbar-expand-lg mb-4">
  <a class="navbar-brand" [href]="sharedDatasSvc.pafEnvironment.logoUrl" target="_blank">
    <img [ngStyle]="sharedDatasSvc.pafEnvironment.logoNgStyle" *ngIf="!sharedDatasSvc.logoIsSvg"
      [src]="'./assets/images/'+sharedDatasSvc.pafEnvironment.logo" />
    <svg-icon [ngStyle]="sharedDatasSvc.pafEnvironment.logoNgStyle" *ngIf="sharedDatasSvc.logoIsSvg"
      [path]="'./assets/images/'+sharedDatasSvc.pafEnvironment.logo"></svg-icon>
  </a>
  <div *ngIf="intUser && pafSettings" class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav">
      <li>
        <a *ngIf="canAccessNewSupplier()" class="nav-link" routerLinkActive="active" routerLink="/new-supplier"
          aria-current="page" paflabel="Demande_de_referencement" (click)="closeMenuOnMobile()">
        </a>
      </li>
      <li *ngIf="intUser">
        <a class="nav-link" routerLink="/suppliers" paflabel="Fournisseurs" (click)="closeMenuOnMobile()"></a>
      </li>
      <li *ngIf="canAccessSourcing()">
        <a class="nav-link" routerLink="/sourcing" paflabel="Sourcing" (click)="closeMenuOnMobile()"></a>
      </li>
      <li *ngIf="listMenuNotEmpty" class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false" paflabel="Listes">
        </a>
        <div class="dropdown-menu">
          <a *ngIf="canAccessMyTasks()" class="nav-link" routerLink="/list-tasks" paflabel="Taches" (click)="closeMenuOnMobile()">
          </a>
          <a *ngIf="canAccessDocLists()" class="nav-link" routerLink="/list-documentaires" paflabel="Documentaires" (click)="closeMenuOnMobile()">
          </a>
          <a *ngIf="canAccessEncours()" class="nav-link" routerLink="/list-encours" paflabel="En_cours" (click)="closeMenuOnMobile()">
          </a>
        </div>
      </li>
      <li *ngIf="canAccessTakapa()" class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false" paflabel="Eti_Finances"></a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" routerLink="/finances/general" (click)="closeMenuOnMobile()">Général</a></li>
          <li><a class="dropdown-item" routerLink="/finances/detail-commandes" (click)="closeMenuOnMobile()">Détail commandes</a></li>
        </ul>
      </li>

      <li *ngIf="ProfilCod=='ADMIN'" class="nav-item dropdown">
        <a paflabel="Administration" class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
          data-bs-toggle="dropdown" aria-expanded="false"></a>
        <ul class="dropdown-menu" aria-labelledby="adminDropdown">
          <li><a class="dropdown-item" [routerLink]="'/administration/extusers'" (click)="closeMenuOnMobile()"
              paflabel="Comptes_utilisateurs_externes"></a></li>
          <li><a class="dropdown-item" [routerLink]="'/administration/relances-documentaires'" (click)="closeMenuOnMobile()"
              paflabel="Relances_documentaires"></a></li>
          <li *ngIf="sharedDatasSvc.canAccessIntUsersAdmin">
            <a class="dropdown-item" [routerLink]="'/administration/intusers'" (click)="closeMenuOnMobile()"
              paflabel="Comptes_utilisateurs_internes"></a>
          </li>
          <li *ngIf="sharedDatasSvc.checkProfilAccessPafSettings('LST_CONTACTS')">
            <a class="dropdown-item" [routerLink]="'/administration/lst-contacts'" paflabel="Contacts" (click)="closeMenuOnMobile()"></a>
          </li>
          <li *ngIf="sharedDatasSvc.checkProfilAccessPafSettings('LST_CONNECTIONS')">
            <a class="dropdown-item" [routerLink]="'/administration/lst-connexions'" (click)="closeMenuOnMobile()"
              paflabel="Connexions_fournisseurs"></a>
          </li>
        </ul>
      </li>
      <li *ngIf="canAccessPBI()">
        <a *ngIf="!isDebug && !!PBI_Url" class="nav-link" paflabel="Power_BI" [href]="PBI_Url" target="_blank" (click)="closeMenuOnMobile()"></a>
        <a *ngIf="isDebug" class="nav-link" paflabel="Power_BI" target="_blank" routerLink="message-ymo" (click)="closeMenuOnMobile()"></a>
      </li>
    </ul>
  </div>
  <div class="navbar-title">{{pafTitle}}</div>
  <button class="navbar-toggler" type="button" *ngIf="intUser && pafSettings"
    (click)="isMenuCollapsed = !isMenuCollapsed" [attr.aria-expanded]="!isMenuCollapsed" aria-controls="mainNavbar"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div *ngIf="!intUser" class="nav-item mx-1">
    <button type="button" class="btn btn-sm btn-secondary mx-1" (click)="connect()" data-toggle="tooltip"
      title="Se connecter au portail fournisseurs">
      Connexion
    </button>
  </div>
  <div *ngIf="intUser" class="nav-item mx-1">
    <!-- <azure-logout-btn></azure-logout-btn> -->
    <a routerLink="/logout" class="btn btn-sm btn-danger fas fa-power-off" title="Déconnexion"
      data-toggle="tooltip"></a>
  </div>
  <form *ngIf="sharedDatasSvc.showDebugButton" class="form-inline small">
    <debug-toolbar></debug-toolbar>
  </form>
</div>